import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import i18n from "@/core/plugins/i18n";
import ElementPlus from "element-plus";
import router from "./router";
import store from "./store";

//imports for app initialization
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import ApiService from "@/core/services/ApiService";

import "@/core/plugins/prismjs";

import { OktaAuth } from '@okta/okta-auth-js'

import OktaVue from '@okta/okta-vue';

import oktaAuth from '@/auth';



const app = createApp(App);

app.use(store);
app.use(router);
app.use(OktaVue, {
  oktaAuth,
  onAuthRequired: () => {
    console.log('onAuthRequired', (app as any).onAuthRequired);
    (app as any)._component.methods.onAuthRequired(oktaAuth);
  },
});

app.use(ElementPlus);

ApiService.init(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");
